
const homepage = {
  // Hero section
  'hero.headline': 'Elit Trading. Artık Herkese Açık.',
  'hero.subheadline': 'Bir zamanlar kurumlara ayrılmış profesyonel yatırım stratejileri — artık The Club aracılığıyla bireysel yatırımcılara sunuluyor',
  'hero.cta.join': 'The Club\'a Katıl',
  'hero.cta.track': 'Performansımızı Takip Et',
  
  // What is The Club section
  'whatIs.header': 'The Club Nedir?',
  'whatIs.subtitle': 'Sizin İçin Yeniden Tanımlanan Profesyonel Trading',
  'whatIs.copy': 'The Club\'da finansal manzarayı yeniden şekillendiriyoruz. Misyonumuz basit: elit, kurumsal düzeyde trading stratejilerini bireysel yatırımcılara erişilebilir kılmak — şeffaflık, performans ve güven özünde. Sıradan insanların bir zamanlar ayrıcalıklı bir finansal dünyaya katılmasına olanak tanıyan sürdürülebilir, uzun vadeli bir iş modeli sunmak. Finansal özgürlüğe erişimi demokratikleştirmek için buradayız — her seferinde bir yatırımcı.',
  'whatIs.cta': 'The Club Ekibiyle Tanışın',
  
  // Why Join section
  'whyJoin.header': 'Neden The Club\'a Katılmalısınız?',
  'whyJoin.subtitle': 'Akıllı, Basit, Güçlü Yatırım',
  'whyJoin.copy': 'Platformumuz, portföyünüzü yöneten birinci sınıf uzmanlar rehberliğinde güvenle servetinizi büyütmenizi sağlar.',
  'whyJoin.feature1.title': 'Sadece 500$ ile başlayın',
  'whyJoin.feature1.desc': 'Engel yok, tavan yok — kendi koşullarınızda büyüyün',
  'whyJoin.feature2.title': 'Şeffaf Performans',
  'whyJoin.feature2.desc': 'Portföy metriklerinize gerçek zamanlı erişim',
  'whyJoin.feature3.title': 'Profesyonel Risk Yönetimi',
  'whyJoin.feature3.desc': 'Sermayenizi korumak ve büyütmek için stratejiler',
  'whyJoin.feature4.title': 'Küresel Destek',
  'whyJoin.feature4.desc': 'Ekibimiz burada — sizin dilinizde, sizin bölgenizde',
  'whyJoin.cta': 'Şimdi Yatırım Yap',
  
  // Trusted Broker section
  'broker.header': 'Güvenilir Broker',
  'broker.subtitle': 'Sermayeniz Güvenli Bir Yuvayı Hak Ediyor',
  'broker.copy': 'Güvenlik ve şeffaflık önemlidir. Bu nedenle yalnızca Seyşeller Finansal Hizmetler Otoritesi (FSA) tarafından lisanslanmış düzenlenmiş bir broker olan Radex Markets ile çalışıyoruz. Radex, müşteri fonlarını ve kişisel verileri korumak için güçlü güvenlik protokolleri uygulayarak müşteri korumasına öncelik verir. Modern yatırımcıların ihtiyaçlarını karşılamak üzere tasarlanmış son teknoloji ve rekabetçi bir trading ortamı sunar.',
  'broker.cta': 'Broker\'ımız Hakkında Daha Fazla Bilgi',
  'broker.badge1': 'Güvenli İşlem',
  'broker.badge2': 'FSA Düzenlemeli',
  'broker.badge3': 'Fon Güvenliği',
  'broker.badge4': 'Şeffaf Operasyonlar',
  
  // Meet Traders section
  'traders.header': 'Yatırımcılarımızla Tanışın',
  'traders.subtitle': 'Gerçek Uzmanlık. Kanıtlanmış Stratejiler.',
  'traders.copy': 'Trading ekibimiz, 2009\'dan bu yana kurumsal algoritmik stratejiler geliştirmede 16 yılı aşkın deneyim sunmaktadır. Küresel piyasalar hakkında derin bir anlayışa sahip olarak, koşullar ne olursa olsun uyum sağlamayı ve performans göstermeyi biliyorlar. Profesyonellerimizden bazıları Pelican Asset Management gibi platformlarda İngiltere\'de ilk 5\'e bile girmiştir. Düşük düşüşlere ve sıkı risk kontrolüne odaklanarak, artık size sonuçlar sunmak için erişilebilir durumdalar.',
  'traders.stats.experience': '16+',
  'traders.stats.experienceLabel': 'Yıllık Deneyim',
  'traders.stats.rank': 'İlk 5',
  'traders.stats.rankLabel': 'İngiltere Trading Sıralaması',
  'traders.stats.since': '2009\'dan beri',
  'traders.stats.sinceLabel': 'Strateji Geliştirme',
  'traders.approach.algorithmic.title': 'Algoritmik Yaklaşım',
  'traders.approach.algorithmic.point1': 'Veriye dayalı karar verme',
  'traders.approach.algorithmic.point2': '2009\'dan beri test edilmiş stratejiler',
  'traders.approach.algorithmic.point3': 'Risk yönetimi parametreleri',
  'traders.approach.risk.title': 'Risk Kontrolü',
  'traders.approach.risk.point1': 'Düşük düşüşlere odaklanma',
  'traders.approach.risk.point2': 'Sıkı pozisyon boyutlandırma kuralları',
  'traders.approach.risk.point3': 'Adaptif piyasa yaklaşımı',
  
  // Performance section
  'performance.header': 'The Club Performansı',
  'performance.subtitle': 'Yatırımcılarımızı İş Başında Görün',
  'performance.recentPerformance': 'Son Performans',
  'performance.monthlyPerformance': 'Aylık Performans',
  'performance.yearlyPerformance': 'Yıllık Projeksiyon',
  'performance.maxDrawdown': 'Maksimum Düşüş',
  'performance.winRate': 'Kazanma Oranı',
  'performance.cta': 'Institutional Strategy\'yi FX Blue\'da Takip Edin',
  'performance.tagline': 'Zirve Performans. Minimum Düşüş. %100 Şeffaflık.',
  'performance.myfxbooktext': 'Benzersiz performans, FX Blue ile doğrulanmış',
  'performance.institutional': 'Kurumsal Strateji',
  'performance.spartanAi': 'Spartan AI',
  'performance.ctaSpartan': 'Spartan AI\'yı Myfxbook\'ta Takip Edin',
  'performance.myfxbookTextSpartan': 'Myfxbook ile doğrulanmış performans',
  'performance.recentPerformanceInstitutional': 'Institutional Strategy Performansı',
  'performance.recentPerformanceSpartan': 'Spartan AI Performansı',
  'performance.strategiesCta': 'Stratejilerimiz Hakkında Daha Fazla Bilgi Edinin',
  
  // How it works section
  'howItWorks.header': 'Nasıl Çalışır',
  'howItWorks.subtitle': 'Basit Kurallar. Net Ödüller.',
  'howItWorks.feature1.title': 'Sadece 500$ ile katılın',
  'howItWorks.feature1.desc': 'Küçük başlayın, istediğiniz zaman büyütün — maksimum limit yok',
  'howItWorks.feature2.title': 'Üyelik Ücreti Yok',
  'howItWorks.feature2.desc': 'Sınırlı bir süre için %20 ücret kaldırıldı. TheClub ile yatırım yapın ve ilk günden kazanmaya başlayın',
  'howItWorks.feature3.title': 'Uyumlu Teşvikler',
  'howItWorks.feature3.desc': '%50 performans ücreti — biz ancak siz kazandığınızda kazanırız',
  'howItWorks.feature4.title': 'İstediğiniz zaman çekin',
  'howItWorks.feature4.desc': 'Sermaye ve kârlara tam erişim — kilitleme süresi yok',
  'howItWorks.feature5.title': 'Para Yatırma ve Çekme Yöntemleri',
  'howItWorks.feature5.desc': 'Visa, Mastercard, banka havalesi ve kripto – hızlı ve esnek',
  'howItWorks.feature6.title': 'KYC ve AML Uyumluluğu',
  'howItWorks.feature6.desc': 'Güvenliğiniz ve düzenleyici güven önceliklerimizdir',
  'howItWorks.cta': 'The Club\'a Katıl',
  'howItWorks.calculator.title': 'Bileşik Faiz ile Büyüme Potansiyelinizi Görün',
  'howItWorks.calculator.results': 'Sonuçlar:',
  'howItWorks.calculator.totalInvestment': 'Toplam Yatırım ($)',
  'howItWorks.calculator.investment': 'Yatırım ($)',
  'howItWorks.calculator.membership': 'Üyelik Ücreti ($)',
  'howItWorks.calculator.monthlyRate': 'Aylık Faiz Oranı (%)',
  'howItWorks.calculator.fiftymonthlyRate': '%50 Aylık Faiz Oranı (%)',
  'howItWorks.calculator.variationRate': 'Aylık Değişim Oranı (%)',
  'howItWorks.calculator.years': 'Yatırım Süresi (Yıl)',
  'howItWorks.calculator.calculate': 'Hesapla',
  'howItWorks.calculator.simpleInvestment': 'Aylık çekim ile gelecek değer',
  'howItWorks.calculator.compoundInvestment': 'Bileşik faiz ile gelecek değer',
  'howItWorks.calculator.difference': 'Fark',
  'howItWorks.calculator.monthAbbr': 'A',
  'howItWorks.calculator.yearAbbr': 'Y',
  'howItWorks.calculator.month': 'Ay',
  'howItWorks.calculator.year': 'Yıl',
  
  // Team section
  'team.header': 'Ekibimizle Tanışın',
  'team.subtitle': 'The Club Vizyonerler Tarafından Yönetilir',
  'team.text': 'The Club\'ın misyonunu şekillendiren ve şeffaflık, bütünlük ve yüksek performans aracılığıyla küresel finansal özgürlüğü teşvik eden beyinlerle tanışın — yatırımı herkes için erişilebilir kılmak.',
  'team.member1': 'Gianluca N. – Yeni Pazarlar \nGeliştirme Başkanı',
  'team.member2': 'Samuel N. – Pazarlama Başkanı',
  'team.member3': 'Marco M. – Broker Danışmanı\n(Radex Markets\nİtalya Başkanı)',
  'team.member4': 'Lloyd S. – Baş Trading Görevlisi',
  'team.member5': 'Horacio A. – Yönetici \nTeknoloji Danışmanı',
  
  // Global Presence section
  'global.header': 'Küresel Varlık',
  'global.subtitle': 'Yerel Yüzler. Küresel Erişim.',
  'global.text': 'İster İtalya\'da, ister Almanya\'da, Orta Doğu\'da veya Latin Amerika\'da olun, yerel destekle buradayız — sizin dilinizde ve sizin saat diliminizde.',
  'global.contact1': 'Germano M. – İtalyanca Konuşan Temsilci',
  'global.contact2': 'Manuel G. – Almanca Konuşan Temsilci',
  'global.contact3': 'Horacio A. – İspanyolca Konuşan Temsilci',
  'global.contact4': 'Aisha R. – İngilizce Konuşan Temsilci',
  'global.contact5': 'XXX XXXX – Fransızca ve Arapça Konuşan Temsilci',
  'global.tagline': 'The Club ile kendi topluluğunuzu büyütmek ister misiniz? Temsilcilerimizden biriyle doğrudan konuşun.',
  
  // Referral section
  'referral.header': 'Referans Programı',
  'referral.subtitle': 'Topluluğunuzu Büyütürken Kazanın',
  'referral.text': 'Fırsatı Paylaşın. Gelirinizi Oluşturun.',
  'referral.copy.default': 'The Club ortağı olarak yalnızca yatırımlarınızdan kazanmakla kalmaz, aynı zamanda başkalarının gelirlerini artırmalarına yardımcı olabilirsiniz. 10 kademeli telafi planımız, uzun vadeli pasif gelir oluşturmanızı sağlar — komisyon ödemeleri her ayın 10\'unda planlanmıştır.',
  'referral.copy.alternate': 'The Club ortağı olarak yalnızca yatırımlarınızdan kazanmakla kalmaz, aynı zamanda başkalarının gelirlerini artırmalarına yardımcı olabilirsiniz. 5 kademeli telafi planımız, uzun vadeli pasif gelir oluşturmanızı sağlar — komisyon ödemeleri her ayın 10\'unda planlanmıştır.',
  'referral.table.level': 'Kademe',
  'referral.table.commission': 'Komisyon',
  'referral.table.levelNumber': 'Kademe {level}',
  'referral.structure.title': 'Kademe Yapısı',
  'referral.commission.title': 'Telafi Planı - Pasif Gelirinizi Oluşturun!',
  'referral.commission.description.default': 'Telafi planı, müşteriler tarafından aylık bazda üretilen kârlara dayalı olarak ilk 10 kademe derinlikte %20\'ye kadar (birleşik) ödeme yapar. Bu, her iş ortağına bileşik faiz etkisi sayesinde gerçek ve büyüyen bir aylık gelir elde etme fırsatı verir; bu da her iş ortağının trading stratejilerimizin yüksek performansı ile desteklenen müşteri portföyünün zamanla büyümesini sağlar.',
  'referral.commission.description.alternate': 'Telafi planı, müşteriler tarafından aylık bazda üretilen kârlara dayalı olarak ilk 5 kademe derinlikte %12\'ye kadar (birleşik) ödeme yapar. Bu, her iş ortağına bileşik faiz etkisi sayesinde gerçek ve büyüyen bir aylık gelir elde etme fırsatı verir; bu da her iş ortağının trading stratejilerimizin yüksek performansı ile desteklenen müşteri portföyünün zamanla büyümesini sağlar.',
  'referral.example.title': 'Örnek Senaryo',
  'referral.example.text': '3 kişiyi yönlendirirseniz ve her biri 1.000$ yatırım yaparsa, ve her biri 2 kişi daha yönlendirirse, topluluğunuzdaki 9 kişinin tamamından komisyon kazanırsınız — güçlü bir pasif gelir akışı oluşturursunuz.',
  
  // New ReferralSection keys
  'referral.you': 'Siz',
  'referral.level1Commission': 'Kademe 1: %5 Komisyon',
  'referral.directReferral': 'Doğrudan Referans',
  'referral.levels2to4Commission': 'Kademe 2-4: %3 Komisyon',
  'referral.levels5to6Commission': 'Kademe 5-6: Her biri %2 Komisyon',
  'referral.level7Commission': 'Kademe 7: %1',
  'referral.level8Commission': 'Kademe 8: %0,5',
  'referral.level9Commission': 'Kademe 9: %0,3',
  'referral.level10Commission': 'Kademe 10: %0,2',
  'referral.communityExpands': 'Topluluğunuz daha derine genişler, {maxLevels} kademeye kadar komisyon kazanırsınız',
  'referral.earnCommissions.default': 'Telafi planı, 10 kademe derinliğe kadar ödeme yapan bir UNILEVEL yapısına dayanmaktadır. Yapımız güçlü bir topluluk oluşturmanızı ödüllendirir.',
  'referral.earnCommissions.alternate': 'Telafi planı, 5 kademe derinliğe kadar ödeme yapan bir UNILEVEL yapısına dayanmaktadır. Yapımız güçlü bir topluluk oluşturmanızı ödüllendirir.',
  'referral.levelSuffix': 'Kademe',
  
  // Events section
  'events.header': 'Etkinlikler ve Topluluk',
  'events.subtitle': 'Bağlantı Kuran Bir Club',
  'events.text': 'Webinarlara katılın, diğer yatırımcılarla tanışın ve daha büyük bir şeyin parçası olun. Neler olduğunu görün — çevrimiçi ve yüz yüze.',
  'events.event1': 'Etkinlikler Yakında',
  'events.event2': 'Etkinlikler Yakında',
  'events.event3': 'Etkinlikler Yakında',
  'events.communityHighlights': 'Topluluk Öne Çıkanları',
  'events.weeklyStrategySessions': 'Haftalık Strateji Oturumları',
  'events.weeklyStrategySessionsDesc': 'Uzmanlarımızla piyasa fırsatlarını analiz edin',
  'events.investorInterviews': 'Yatırımcı Röportajları',
  'events.investorInterviewsDesc': 'Büyüyen topluluğumuzdan başarı hikayelerini dinleyin',
  'events.educationalResources': 'Eğitim Kaynakları',
  'events.tradingFundamentals': 'Trading Temelleri',
  'events.tradingFundamentalsDesc': 'Trading\'i anlamak için ücretsiz kılavuzlar',
  'events.expertWebinars': 'Uzman Webinarları',
  'events.expertWebinarsDesc': 'Deneyimli kullanıcılar için ileri düzey konular',
  
  // Connect section
  'connect.header': 'Bağlantıda Kalın',
  'connect.subtitle': 'İletişimde Kalalım',
  'connect.whatsapp': 'WhatsApp ile bize ulaşın',
  'connect.language.english': 'English',
  'connect.language.italian': 'Italiano',
  'connect.language.spanish': 'Español',
  'connect.language.german': 'Deutsch',
  'connect.language.croatian': 'Hrvatski',
  'connect.language.turkish': 'Türkçe',
  'connect.language.french': 'Français',
  'connect.language.arabic': 'العربية',
  
  // Footer section
  'footer.rights': 'Tüm hakları saklıdır.',
  'footer.terms': 'Kullanım Koşulları',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.cookies': 'Çerezler',
  'footer.contactMe': 'Bana ulaşın',
  
  // Strategies page
  // 'strategies.heroSubtitle': 'İki Strateji. Bir Vizyon. Maksimum Koruma ve Büyüme.',
  'strategies.pageTitle': 'TheClub Stratejileri',
  'strategies.heroSubtitle': 'Bir Vizyon. Maksimum Koruma ve Büyüme.',
  'strategies.learnMore': 'Daha Fazla Bilgi',
  'strategies.showLess': 'Daha Az Göster',

  // Institutional Strategy
  'strategies.institutional.tagline': 'Hassasiyet. İstikrar. Kurumsal Düzeyde Koruma.',
  'strategies.institutional.highlight1': '16 Yıllık Deneyim',
  'strategies.institutional.highlight1Desc': 'Hedge fon ve Deutsche Bank geçmişine sahip İngiliz kurumsal traderlar',
  'strategies.institutional.highlight2': 'Gold ve GU Odağı',
  'strategies.institutional.highlight2Desc': 'Gold ve Sterlin/Dolar üzerinde orta/yüksek frekanslı algoritmalar',
  'strategies.institutional.highlight3': 'Aylık %5–6 Hedef',
  'strategies.institutional.highlight3Desc': 'Yıllık ortalama %35–40 tutarlı getiriler',
  'strategies.institutional.highlight4': 'Kontrollü Risk',
  'strategies.institutional.highlight4Desc': 'Sermaye korumasını önceliklendiren muhafazakâr yaklaşım',
  'strategies.institutional.description': 'İngiliz kurumsal traderlarımız tarafından doğrudan yönetilen bir stratejidir; 16 yıldır finans piyasalarında faaliyet gösteren bir çalışma grubudur. İngiltere\'deki en önemli hedge fonlarından biri ve Deutsche Bank ile çalışmışlardır. Başlıca Gold ve GU (Sterlin/Dolar) üzerinde orta/yüksek frekansta çalışan algoritmaların oluşturulması ve sürekli güncellenmesi konusunda uzmanlaşmışlardır. The Club ile ilk yılda zaten elde edildiği gibi aylık ortalama %5–6 elde etmeyi hedefleyen, müşteriye yıllık yaklaşık %35–40 ortalama sağlamak amacıyla nispeten kontrollü riski sürdüren bir stratejidir.',

  // Spartan AI Strategy
  'strategies.spartanAi.tagline': 'Agresif. Akıllı. Spartan Düzeyinde Performans.',
  'strategies.spartanAi.highlight1': 'AI Destekli',
  'strategies.spartanAi.highlight1Desc': 'İtalyan traderlar tarafından sürekli güncellenen yapay zekâ',
  'strategies.spartanAi.highlight2': 'Gün İçi Gold',
  'strategies.spartanAi.highlight2Desc': 'AI operasyonlarını manuel işlemlerle birleştiren yarı manuel strateji',
  'strategies.spartanAi.highlight3': 'Daha Yüksek Kâr Potansiyeli',
  'strategies.spartanAi.highlight3Desc': 'Üstün getiriler sağlayan daha agresif yaklaşım',
  'strategies.spartanAi.highlight4': '%20 Equity Stop',
  'strategies.spartanAi.highlight4Desc': 'Institutional Strategy kârları ile karşılanan maksimum kayıp koruması',
  'strategies.spartanAi.description': 'Trading dünyasında 6 yıldır profesyonel olarak mükemmel sonuçlarla çalışan İtalyan trader grubumuz tarafından oluşturulan ve sürekli güncellenen bir yapay zekâdır. Yarı manuel şekilde çalışan daha agresif bir stratejidir: traderların kendileri AI\'ın operasyonlarını kendi manuel işlemleriyle birleştirerek çalışır. Yalnızca Gold üzerinde gün içi çalışır. Çok daha yüksek kârlar üretme eğiliminde olan ancak aynı zamanda %20 equity stop\'a sahip bir stratejidir. Bu, müşterinin Spartan AI\'a yatırılan sermayenin %20\'sinden fazlasını asla kaybedemeyeceği anlamına gelir; bu sermaye, yılda bir kez bu equity stop\'a ulaşılması durumunda Institutional Strategy tarafından kârlarıyla karşılanır.',

  // Strategy Bond (50/50)
  'strategies.bond.title': 'Birlikte Daha Güçlü: 50/50 Yaklaşımı',
  'strategies.bond.description': 'Her yatırım stratejik olarak her iki strateji arasında 50/50 bölünür. Institutional Strategy sermayenizi koruyan istikrarlı, muhafazakâr bir temel sağlarken, Spartan AI agresif büyüme potansiyeli sunar. Spartan AI\'ın %20 equity stop\'una ulaştığı nadir durumlarda, Institutional Strategy\'nin tutarlı kârları bir güvenlik ağı görevi görür — genel yatırımınızın korunmuş ve büyüyor kalmasını sağlar.',
  'strategies.bond.benefit1': 'Maksimum Koruma',
  'strategies.bond.benefit1Desc': 'Institutional Strategy kârları Spartan AI equity stop\'larına karşı koruma sağlar',
  'strategies.bond.benefit2': 'Akıllı Çeşitlendirme',
  'strategies.bond.benefit2Desc': 'İki farklı yaklaşım genel portföy riskini azaltır',
  'strategies.bond.benefit3': 'Optimize Edilmiş Büyüme',
  'strategies.bond.benefit3Desc': 'Muhafazakâr istikrar agresif kâr potansiyeli ile buluşur',

  // Floating button
  'floatingButton.embassador.title': 'The Club Elçisi Olun',
  'floatingButton.embassador.text': 'Referans programımıza katılın ve başkalarının finansal özgürlüğe ulaşmasına yardımcı olurken harika komisyonlar kazanın. Club elçisi olarak yolculuğunuza bugün başlamak için WhatsApp ile bize ulaşın!',
  'floatingButton.embassador.button': 'The Club Elçisi Olun',
  'floatingButton.embassador.contact': 'Bir Temsilciyle Bağlantı Kurun',
  'floatingButton.embassador.feature1': 'Topluluğunuzu oluşturun',
  'floatingButton.embassador.feature2': '{maxLevels} kademeye kadar komisyon kazanın',
  'floatingButton.embassador.feature3': 'Zamanında ödemeler, her ayın 15\'inde planlanmış',
};

export default homepage;
